import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=093d3e53&"
import script from "./FlagIcon.vue?vue&type=script&lang=ts&"
export * from "./FlagIcon.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./FlagIcon.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('093d3e53')) {
      api.createRecord('093d3e53', component.options)
    } else {
      api.reload('093d3e53', component.options)
    }
    module.hot.accept("./FlagIcon.vue?vue&type=template&id=093d3e53&", function () {
      api.rerender('093d3e53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/FlagIcon.vue"
export default component.exports